// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jf-0";
export var animationContainer = "_jf-1";
export var itemPrice = "_jf-a";
export var itemizedContent = "_jf-9";
export var itemizedHeader = "_jf-7";
export var itemizedRow = "_jf-8";
export var itemizedSection = "_jf-6";
export var modalContent = "_jf-2";
export var orderName = "_jf-3";
export var refundOption = "_jf-4";
export var refundOptionsContainer = "_jf-5";
export var shippingLabel = "_jf-b";
export var totalRow = "_jf-c";